import AuthAPI from './authInstance'

const getAll = async (data) => {
  const response = await AuthAPI.get(`/admin/examtype`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/examtype/show/${data}`)
  return response.data
}

const createExamType = async (data) => {
  const response = await AuthAPI.post(`/admin/examtype/create`, data)
  return response.data
}

const editExamType = async (data) => {
  const response = await AuthAPI.post(`/admin/examtype/update`, data)
  return response.data
}

const deleteOne = async (data) => {
  const response = await AuthAPI.delete(`/admin/examtype/delete/${data}`)
  return response.data
}

export const examTypeService = {
  getAll,
  getOne,
  createExamType,
  editExamType,
  deleteOne,
}
